import { Component } from 'preact'
import { ContentType } from '@insided/shared/utils/contentType'
import { PageUnloadContext } from '@insided/shared/services/PageUnloadContext'
import PostEditor from '@insided/shared/uikit/PostEditor'
import Reports from '../Reports'
import { ReportedContent } from '../Report'

/* eslint-disable import/no-internal-modules */
import Content from '@insided/deprecated-preact-components/common/Content'

export interface ReplyContentProps {
  id: string
  topicId: number
  contentType: ContentType
  content: string | null
  showEditor: boolean
  onCancel: () => void
  onSave: (content: string) => void
  onShowAlert: (type: 'success' | 'error', message?: string) => void
  reportedContent: ReportedContent[]
}

export interface ReplyContentState {
  content: string | null
  isLoading: boolean
}

class ReplyContent extends Component<ReplyContentProps, ReplyContentState> {
  constructor (props: ReplyContentProps) {
    super(props)
    this.state = {
      ...props,
      isLoading: false
    }
    this.onCancel = this.onCancel.bind(this)
    this.onChange = this.onChange.bind(this)
    this.onSave = this.onSave.bind(this)
  }

  onChange (content: string) {
    this.setState({ content })
  }

  onCancel () {
    const { content, onCancel } = this.props
    this.setState({ content })
    onCancel()
  }

  onSave (content: string) {
    const { onSave } = this.props
    this.setState({ content })
    onSave(content)
  }

  render () {
    const { showEditor, topicId, contentType, id, content: data, reportedContent } = this.props
    const { content } = this.state

    if (showEditor) {
      return (
        <div className='post--content post--content-new-editor'>
          <PageUnloadContext.Consumer>
            {({ lock, unlock }) => {
            return (
              <PostEditor
                replyId={Number(id)}
                topicId={topicId}
                isControl
                data={content ?? ''}
                onSuccess={(content) => {
                  unlock()
                  this.onSave(content)
                }}
                onCancel={() => {
                  unlock()
                  this.onCancel()
                }}
                onChange={(content) => {
                  this.onChange(content)
                  lock(content, data)
                }}
                type={contentType}
                redirect={false}
                isGuest={false}
                disableFileAttachments={false}
              />
            )
          }}
          </PageUnloadContext.Consumer>
        </div>
      )
    }
    return (
      <div className='post--content post--content-new-editor'>
        <Content
          content={content ?? ''}
          className='qa-post-content'
          isControl
        />
        {reportedContent.length > 0 && (
          <Reports reportedContent={reportedContent} />
        )}
      </div>
    )
  }
}

export default ReplyContent
